export function isSyncAvailabled(lastSyncedTimestamp: string, limitMinutes: number): boolean {
  const now = new Date()
  const diff = Math.abs(now.getTime() - new Date(lastSyncedTimestamp).getTime())
  const diffMinutes = Math.floor(diff / 1000 / 60)
  return diffMinutes > limitMinutes
}



// WEBPACK FOOTER //
// ./src/libs/isSyncAvailabled/index.tsx